import jwt_decode from "jwt-decode";
export const userType = () => {
  const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = window.document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };
  const token = getCookie("token");
  let isSeeker = false,
    isGiver = false;
  if (token) {
    var decoded = jwt_decode(token);
    if (decoded.user_type === "seeker") {
      isSeeker = true;
    } else if (decoded.user_type === "giver") {
      isGiver = true;
    } else if (decoded.user_type === "both") {
      isGiver = true;
      isSeeker = true;
    }
  }
  return { isSeeker, isGiver };
};
